module.exports = __webpack_public_path__ + "static/img/distance.3f209a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/distance.png
// module id = vccr
// module chunks = 1